import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-16" data-mp="3iq82w711t4dw">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-17" data-mp="3ipy9sakpih3z">
        <SectionHeading id="beneficios" title="¿Qué puede cambiar cuando empiezas?" subtitle="Una habilidad técnica puede abrir nuevas posibilidades." data-id="element-18" data-mp="3no9jmlb04rm7" />

        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-19" data-mp="3drdhcxbp51q3">
          {benefits.map((b, i) => <Reveal key={b.title} as="li" delay={i * 0.03} className="flex gap-3 rounded-xl border border-mist bg-white p-3" data-id="element-20" data-mp="2zs43i4ayqjpa" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-navy text-lg" aria-hidden="true" data-id="element-21" data-mp="xzpnxbvw5rc1">
                {b.emoji}
              </span>
              <div data-id="element-22" data-mp="2bdut2vqd4mda">
                <h3 className="font-display text-sm font-extrabold text-navy" data-id="element-23" data-mp="2bdcrrkoufhyi">
                  {b.title}
                </h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-graphite-muted sm:text-sm" data-id="element-24" data-mp="2l4z79t87s372">
                  {b.desc}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}